export default __webpack_public_path__ + "static/media/36I-114280_-20510_0.4e5c9492.jpg";